import { Notification } from './../../../../../types/notification';
import { Community, NotificationCommunity, NotificationRecordable, NotificationSubGroup, SubGroup } from './../../../../../types';

export class NotificationViewModel extends Notification {
    selectedCommunities: Community[] = [];
    selectedSubGroup: SubGroup = null;

    setProperties(notification: Notification, allCommunities: Community[], allSubGroups: SubGroup[]): void {
        this.notificationId = notification.notificationId;
        this.notificationTypeId = notification.notificationTypeId;
        this.notificationTypeName = notification.notificationTypeName;
        this.edhMarketId = notification.edhMarketId;
        this.edhContactId = notification.edhContactId;
        this.createdBy = notification.createdBy;
        this.createdUtcDate = notification.createdUtcDate;
        this.lastModifiedBy = notification.lastModifiedBy;
        this.lastModifiedUtcDate = notification.lastModifiedUtcDate;
        this.notificationCommunities = notification.notificationCommunities;
        this.notificationSubGroup = notification.notificationSubGroup;

        //#region Convert PCP properties to EDH properties
        if (notification.notificationCommunities) {
            this.selectedCommunities = notification.notificationCommunities
                .map((nc: NotificationCommunity) => this.getEdhCommunity(nc, allCommunities));
        } else {
            this.selectedCommunities = [];
        }

        this.selectedSubGroup = notification.notificationSubGroup ? this.getEdhSubGroup(notification.notificationSubGroup, allSubGroups) : null;
        //#endregion
    }

    mapEdhPropertiesToPcpProperties(marketId: number) {
        this.notificationCommunities = this.getPcpCommunities();
        this.notificationSubGroup = this.getPcpSubGroup();
        this.edhMarketId = marketId;
    }

    getEdhCommunity(notificationCommunity: NotificationCommunity, allCommunities: Community[]): Community {
        return allCommunities.find((c) => c.orgId === notificationCommunity.edhFinancialCommunityId);
    }

    getEdhSubGroup(notificationSubGroup: NotificationSubGroup, allSubGroups: SubGroup[]): SubGroup {
        return notificationSubGroup.subGroupId > 0 ? allSubGroups.find((s) => s.subGroupID === notificationSubGroup.subGroupId) : null;
    }

    getPcpCommunities(): NotificationCommunity[] {

        if (this.selectedCommunities.length > 0) {
            return this.selectedCommunities.map((c: Community) => {
                const notificationCommunity = new NotificationCommunity();
                notificationCommunity.edhFinancialCommunityId = c.orgId;
                notificationCommunity.notificationId = this.notificationId;
                return notificationCommunity;
            });
        }

        return [];
    }

    getPcpSubGroup(): NotificationSubGroup {
        let notificationSubGroup = null;
        if (this.selectedSubGroup) {
            notificationSubGroup = new NotificationSubGroup();
            notificationSubGroup.subGroupId = this.selectedSubGroup.subGroupID;
            notificationSubGroup.notificationId = this.notificationId;
        }
        return notificationSubGroup;
    }

    getNotification(): Notification {

        const notification: Notification = new Notification();

        notification.notificationId = this.notificationId;
        notification.notificationTypeId = this.notificationTypeId;
        notification.notificationTypeName = this.notificationTypeName;
        notification.edhMarketId = this.edhMarketId;
        notification.edhContactId = this.edhContactId;
        notification.createdBy = this.createdBy;
        notification.createdUtcDate = this.createdUtcDate;
        notification.lastModifiedBy = this.lastModifiedBy;
        notification.lastModifiedUtcDate = this.lastModifiedUtcDate;
        notification.notificationCommunities = this.notificationCommunities;
        notification.notificationSubGroup = this.notificationSubGroup;

        return notification;
    }
}
